<template>
  <div class="ads-page-header d-md-flex align-items-center justify-content-between mb-20">
    <div class="d-flex align-items-center">
      <span class="ads-page-icon">
        <i class="ph ph-warning-circle"></i>
      </span>
      <div class="ms-12">
        <h4 class="mb-0 fw-bold">Gestion des réclamations</h4>
        <p class="mb-0 text-muted fs-13">
          {{ users.total || rows.length }} réclamation{{ (users.total || rows.length) > 1 ? "s" : "" }} au total
        </p>
      </div>
    </div>
  </div>

  <div class="card ads-card mb-25 border-0 letter-spacing">
    <div class="ads-filters row align-items-end g-10 p-15 p-sm-20 p-md-25 pb-0">
      <div class="col-md-4 mb-3">
        <label class="fw-medium mb-10 d-block">Statut</label>
        <v-select
                    label="name"
                    :options="objectsClaim"
                    v-model="object_filter"
                  />


      </div>

      <!-- Client -->
      <div class="col-md-4 mb-3">
        <label class="fw-medium mb-10 d-block">Client</label>
        <v-select
          v-model="customer_filter"
          label="name"
          :options="clientList"
          placeholder="Client (Tous)"
          @search="filterClients"
        >
          <template #no-options>Taper un mot pour chercher un client</template>
        </v-select>
      </div>

      <!-- Buttons -->
      <div class="col-md-4 text-md-end mb-3">
        <button class="ads-btn-primary border-0 transition fw-medium me-2" @click="applyFilters">
          <i class="flaticon-filter me-1"></i>
          Filtrer
        </button>

        <button class="ads-btn-outline transition fw-medium" @click="resetFilters">
          <i class="flaticon-refresh me-1"></i>
          Annuler
        </button>
      </div>
    </div>
    <div
      class="card-head d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25"
    >
      <div class="d-sm-flex align-items-center">
        <button
          class="ads-btn-outline position-relative transition fw-medium d-inline-flex align-items-center mb-10 mb-lg-0"
          type="button"
          @click="exportClaims()"
        >
          <i class="flaticon-file-1 position-relative fs-15 me-8"></i>
          Export
        </button>
      </div>
      <div class="ads-search position-relative">
        <i class="flaticon-search ads-search-icon"></i>
        <input
          type="text"
          class="form-control ps-40"
          placeholder="Rechercher une réclamation..."
           v-model="searchTerm"
            @input="handleInput"
        />
      </div>
    </div>
    <div class="card-body p-15 p-sm-20 p-md-25 pt-0">
      <div v-if="loading" class="skeleton-table w-100">
        <div class="loading-spinner-wrap text-center py-15">
          <div class="spinner-border text-success" role="status">
            <span class="visually-hidden">Chargement...</span>
          </div>
        </div>
        <div
          class="skeleton-row d-flex align-items-center"
          v-for="n in 6"
          :key="n"
        >
          <div
            class="skeleton-cell"
            v-for="c in headers.length"
            :key="c"
          >
            <span class="skeleton-bar"></span>
          </div>
        </div>
      </div>
      <vue-good-table v-else class="ads-good-table" :columns="headers" :rows="rows">
        <!-- Empty state -->
        <template #emptystate>
          <div class="empty-state text-center py-40">
            <i class="ph ph-warning-circle fs-40 d-block mb-10 text-muted"></i>
            <p class="mb-0 text-muted">Aucune entrées correspondantes trouvées</p>
          </div>
        </template>

        <!-- Custom row -->
        <template #table-row="props">
          <span v-if="props.column.field == 'created_at'">
            {{ getDate(props.row.created_at) }}
          </span>

          <span v-else-if="props.column.field === 'statut'">
            <span
              v-if="props.row.statut == 4"
              class="status-pill status-pill-warning"
            >
              <span class="status-pill-dot"></span>
              En cours de traitement
            </span>
            <span
              v-if="props.row.statut == 1"
              class="status-pill status-pill-info"
            >
              <span class="status-pill-dot"></span>
              Réponse service
            </span>

            <span
              v-if="props.row.statut == 2"
              class="status-pill status-pill-primary"
            >
              <span class="status-pill-dot"></span>
              Réponse client
            </span>
            <span
              v-if="props.row.statut == 3"
              class="status-pill status-pill-success"
            >
              <span class="status-pill-dot"></span>
              Réclamation traitée
            </span>
          </span>

          <span v-else-if="props.column.field === 'name'">
            <a
              @click.prevent="
                $router.push({
                  name: 'EditCustomerPage',
                  params: { id: props.row.customer_id },
                })
              "
              class="dropdown-item d-flex align-items-center"
              href="javascript:void(0);"
            >
              {{ props.row.client?.store }}
            </a>
          </span>

          <span v-else-if="props.column.field === 'city'">
            {{ props.row.city?.city }}
            <!-- <a target='_blank' :href="`${API_BASE_URL}/customer_details/${props.row.customer_id}`">{{props.row.store}}</a> -->
          </span>

          <!-- <template v-else-if="props.column.field === 'note'">
              <button
                style="margin-right: 1px; margin-left: 1px"
                variant="danger"
                class="btn-icon"
                title="Une remarque"
                @click="showDetailNote(props.row)"
              >
              </button>
            </template> -->
          <span v-else-if="props.column.field === 'created_at'">
            <h5>{{ getDate(props.row.created_at) }}</h5>

            <template
              v-if="props.row.taken_by_name && props.row.taken_by_name != ''"
            >
              Pris par: <span>{{ props.row.taken_by_name }}</span>
            </template>
          </span>

          <span v-else-if="props.column.field === 'last_response_by_name'">
            {{ props.row.last_response_by_name }}<br />
            <small>{{ getDate(props.row.response_time) }}</small>
          </span>

          <span v-else-if="props.column.field === 'code_colis'">
            {{ props.row.code_colis }}
          </span>

          <span v-else-if="props.column.field === 'object'">
            <b>{{ props.row.object }}</b
            ><br />
            <small style="color: #f08016"
              >{{ props.row.code_colis }}

              <template v-if="props.row.new_price">
                -
                <b
                  >{{ props.row.new_price }} {{ settingData[0]?.devis }}</b
                ></template
              >

              <template v-if="props.row.new_price_remb">
                -
                <b
                  >{{ props.row.new_price_remb }} {{ settingData[0]?.devis }}</b
                ></template
              >
            </small>
            <div class="action-buttons mt-10 mt-sm-0 d-flex align-items-center">
              <button
                class="bg-transparent p-0 border-0 text-black transition lh-1"
                @click="showObject(props.row)"
              >
                <i class="ph-duotone ph-pen"></i>
              </button>
            </div>

            <!-- <small class="text-muted">{{ props.row.code_colis }}</small> -->
          </span>

          <span v-else-if="props.column.field === 'action'">
            <div class="dropdown">
              <button
                class="dropdown-toggle card-dot-btn lh-1 position-relative top-4 bg-transparent border-0 shadow-none p-0 transition"
                type="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <i class="flaticon-dots"></i>
              </button>
              <ul class="dropdown-menu">
                <!-- Conversation -->
                <li>
                  <a
                    class="dropdown-item d-flex align-items-center"
                    href="javascript:void(0);"
                    @click.prevent="showUpdate(props.row)"
                  >
                    <i
                      class="ph ph-chat-circle-dots lh-1 me-8 position-relative top-1"
                    ></i>
                    Conversation
                  </a>
                </li>

                <!-- En cours de traitement -->
                <li v-if="props.row.statut !== 3 && props.row.statut !== 4">
                  <a
                    class="dropdown-item d-flex align-items-center"
                    href="javascript:void(0);"
                    @click="processedClaim(props.row)"
                  >
                    <i
                      class="ph ph-clock lh-1 me-8 position-relative top-1"
                    ></i>
                    En cours de traitement
                  </a>
                </li>

                <!-- Traiter la réclamation -->
                <li v-if="props.row.statut !== 3">
                  <a
                    class="dropdown-item d-flex align-items-center"
                    href="javascript:void(0);"
                    @click="showDetails(props.row)"
                  >
                    <i
                      class="ph ph-check-circle lh-1 me-8 position-relative top-1"
                    ></i>
                    Traiter la réclamation
                  </a>
                </li>

                <!-- Groupe Whatsapp -->
                <li v-if="props.row.city?.lien">
                  <a
                    class="dropdown-item d-flex align-items-center"
                    :href="props.row.city?.lien"
                    target="_blank"
                  >
                    <i
                      class="ph ph-whatsapp-logo lh-1 me-8 position-relative top-1"
                    ></i>
                    Groupe Whatsapp
                  </a>
                </li>

                <!-- Historique -->
                <!-- <li>
                  <a
                    class="dropdown-item d-flex align-items-center"
                    href="javascript:void(0);"
                    @click.prevent="
                      $router.push({
                        name: 'HistoryClaimPage',
                        params: { id: props.row.id },
                      })
                    "
                  >
                    <i class="ph ph-list lh-1 me-8 position-relative top-1"></i>
                    Historique
                  </a>
                </li> -->
              </ul>
            </div>
          </span>

          <span v-else>
            {{ props.formattedRow[props.column.field] }}
          </span>
        </template>
      </vue-good-table>
      <PaginatorContent :pagination="users" :offset="9" @paginate="fetchData" />
    </div>
  </div>

  <div class="modal fade" id="chatClaimModal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-xl">
      <div class="modal-content ads-modal-content">
        <div class="modal-header ads-modal-header">
          <div class="d-flex align-items-center">
            <span class="ads-modal-icon">
              <i class="ph ph-chat-circle-dots"></i>
            </span>
            <h5 class="modal-title ms-12 mb-0">Conversation réclamation</h5>
          </div>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>

        <div class="modal-body">
          <ChatClaim
            :messages="chatMsgs"
            :fetchMessages="fetchMessages"
            :rowClaim="showClaim"
          />
        </div>

        <!-- <div class="modal-footer">
          <button
            type="button"
            class="btn btn-secondary"
            data-bs-dismiss="modal"
          >
            Fermer
          </button>
        </div> -->
      </div>
    </div>
  </div>

  <div class="modal fade" id="infosClaimModal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-lg">
      <div class="modal-content ads-modal-content">
        <div class="modal-header ads-modal-header">
          <div class="d-flex align-items-center">
            <span class="ads-modal-icon">
              <i class="ph ph-check-circle"></i>
            </span>
            <h5 class="modal-title ms-12 mb-0">Informations réclamation</h5>
          </div>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>

        <div class="modal-body">
          <form @submit.prevent="traitClaim">
            <!-- Object -->
            <div class="form-group mb-3">
              <label for="object">Object</label>
              <input
                id="object"
                v-model="formClaim.object"
                disabled
                class="form-control"
              />
            </div>

            <hr />

            <!-- Colis (conditional) -->
            <div
              class="form-group mb-3"
              v-if="
                [
                  'Changement de prix',
                  'Relance Colis/Client',
                  'Annulation Colis',
                ].includes(formClaim.object)
              "
            >
              <label for="colis">Colis</label>
              <input
                id="colis"
                v-model="formClaim.code_colis"
                disabled
                class="form-control"
              />
            </div>

            <!-- Adresse/Client case -->
            <div
              v-if="formClaim.object === 'Changement Adresse/Client'"
              class="form-group mb-3"
            >
              <div>
                <label for="colis">Colis</label>
                <input
                  id="colis"
                  v-model="formClaim.code_colis"
                  disabled
                  class="form-control"
                />
              </div>
            </div>

            <!-- Nouveau Prix -->
            <div
              v-if="formClaim.object === 'Changement de prix'"
              class="form-group mb-3"
            >
              <label for="price">Nouveau Prix</label>
              <input
                id="price"
                v-model="formClaim.new_price"
                disabled
                class="form-control"
              />
            </div>

            <!-- Rembourssement -->
            <div
              v-if="formClaim.object === 'Rembourssement'"
              class="form-group mb-3"
            >
              <label for="price_remb">Nouveau Prix</label>
              <input
                id="price_remb"
                v-model="formClaim.new_price_remb"
                disabled
                class="form-control"
              />
            </div>

            <!-- City -->
            <div
              :class="
                formClaim.object === 'Changement Adresse/Client'
                  ? 'form-group mb-3'
                  : 'form-group mb-3'
              "
            >
              <label for="city">Ville</label>
              <input
                id="city"
                v-model="formClaim.city_name"
                disabled
                class="form-control"
              />
            </div>

            <!-- Adresse -->
            <div
              v-if="formClaim.object === 'Changement Adresse/Client'"
              class="form-group mb-3"
            >
              <label for="adresse">Adresse</label>
              <textarea
                id="adresse"
                v-model="formClaim.adresse"
                rows="3"
                class="form-control"
              ></textarea>
            </div>

            <!-- Commentaire -->
            <div
              :class="
                formClaim.object === 'Changement Adresse/Client'
                  ? 'form-group mb-3'
                  : 'form-group mb-3'
              "
            >
              <label for="comment">Commentaire</label>
              <textarea
                id="comment"
                v-model="formClaim.msg"
                rows="3"
                class="form-control"
              ></textarea>
            </div>

            <!-- Nouveau Client + Téléphone -->
            <div
              v-if="formClaim.object === 'Changement Adresse/Client'"
              class="form-group mb-3"
            >
              <div class="form-group mb-3">
                <label for="new_receiver">Nouveau Client</label>
                <input
                  id="new_receiver"
                  v-model="formClaim.new_receiver"
                  class="form-control"
                />
              </div>
              <div class="form-group mb-3">
                <label for="new_phone">Téléphone</label>
                <input
                  id="new_phone"
                  v-model="formClaim.new_phone"
                  class="form-control"
                />
              </div>
            </div>
          </form>
        </div>

        <div class="modal-footer ads-modal-footer">
          <button
            type="button"
            class="ads-btn-outline transition fw-medium"
            data-bs-dismiss="modal"
          >
            Fermer
          </button>
          <button type="button" @click="traitClaim" class="ads-btn-primary border-0 transition fw-medium">
            Traiter la réclamation
          </button>
        </div>
      </div>
    </div>
  </div>

  <div
    class="modal fade"
    id="chnageObjectClaimModal"
    tabindex="-1"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-xl">
      <div class="modal-content ads-modal-content">
        <div class="modal-header ads-modal-header">
          <div class="d-flex align-items-center">
            <span class="ads-modal-icon">
              <i class="ph ph-pen"></i>
            </span>
            <h5 class="modal-title ms-12 mb-0">Changer objet</h5>
          </div>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>

        <div class="modal-body">
          <form @submit.prevent="editObjectClaim">
            <!-- Type de réclamation -->
            <div class="form-group mb-3">
              <label for="type">Type de réclamation</label>
              <select class="form-select" v-model="formObject.new_object">
                <option
                  v-for="option in objectsClaim"
                  :key="option.id"
                  :value="option"
                >
                  {{ option.name }}
                </option>
              </select>
            </div>

            <!-- Nouveau prix -->
            <div
              v-if="formObject.new_object?.name === 'Changement de prix'"
              class="form-group mb-3"
            >
              <label for="price">Nouveau prix *</label>
              <input
                id="price"
                type="number"
                min="0"
                v-model="formObject.price"
                placeholder="Nouveau prix *"
                class="form-control"
              />
            </div>

            <!-- Changement Adresse/Client -->
            <template
              v-if="formObject.new_object?.name === 'Changement Adresse/Client'"
            >
              <div class="form-group mb-3">
                <label for="adresse">Nouvelle Adresse</label>
                <textarea
                  id="adresse"
                  rows="2"
                  v-model="formObject.adresse"
                  placeholder="Nouvelle Adresse"
                  class="form-control"
                ></textarea>
              </div>

              <div class="form-group mb-3">
                <label for="receiver">Nouveau Destinataire</label>
                <input
                  id="receiver"
                  v-model="formObject.reciever"
                  placeholder="Nouveau Destinataire"
                  class="form-control"
                />
              </div>

              <div class="form-group mb-3">
                <label for="phone">Nouveau Numéro Téléphone</label>
                <input
                  id="phone"
                  name="Téléphone"
                  type="text"
                  v-model="formObject.phone"
                  placeholder="Nouveau Numéro Téléphone"
                  class="form-control"
                />
              </div>
            </template>

            <!-- Message -->
            <div class="form-group mb-3">
              <label for="msg">Message *</label>
              <textarea
                id="msg"
                rows="2"
                v-model="formObject.msg"
                placeholder="Message *"
                class="form-control"
              ></textarea>
            </div>
          </form>
        </div>

        <div class="modal-footer ads-modal-footer">
          <button
            type="button"
            class="ads-btn-outline transition fw-medium"
            data-bs-dismiss="modal"
          >
            Fermer
          </button>
          <button
            type="button"
            @click="editObjectClaim"
            class="ads-btn-primary border-0 transition fw-medium"
          >
            Traiter la réclamation
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { useAppToast } from "@/composables/useAppToast";
import api from "@/utils/axios";
import moment from "moment";
import Swal from "sweetalert2";
import { defineComponent, nextTick, onMounted, reactive, ref } from "vue";
import { useAuthStore } from "@/stores/auth";
import { Modal } from "bootstrap";
import ChatClaim from "./ChatClaim.vue";

export default {
  name: "NewCustomers",
  components: {
    ChatClaim, // register here
  },
  setup: () => {
    const { showToast } = useAppToast();

    const auth = useAuthStore();
    const user = auth.user;

    const headers = [
      //   {
      //     label: "",
      //     field: "note",
      //   },
      {
        label: "Référence",
        field: "code",
      },
      {
        label: "Client",
        field: "name",
      },
      {
        label: "Object",
        field: "object",
      },
      {
        label: "Colis",
        field: "code_colis",
      },
      {
        label: "Etat",
        field: "statut",
      },
      {
        label: "Ville",
        field: "city",
      },
      {
        label: "Date d'ajout",
        field: "created_at",
      },
      {
        label: "Répondu par :",
        field: "last_response_by_name",
      },
      //   {
      //     label: "Durée de réponse",
      //     field: "duration",
      //   },
      {
        label: "Actions",
        field: "action",
      },
    ];

    const objectsClaim = ref([]);

    const rows = ref([]);
    const loading = ref(false);
    const settingData = ref<any[]>([]);

    const showClaim = reactive({});
    const chatMsgs = ref([]);

    const users = reactive({
      searchCustomer: "",
      searchStore: "",
      searchCity: "",
      searchObject: "",
      searchStatut: "",
      searchSDate: "",
      searchEDate: "",
      searchTerm: "",
      searchUser: "",
      total: 0,
      per_page: 10,
      from: 1,
      to: 0,
      current_page: 1,
    });

    const formClaim = reactive({
      colis_id: 0,
      id: 0,
      customer_id: 0,
      msg: "",
      object: "",
      city_id: 0,
      statut: "",
      code_colis: "",
      city: "",
      adresse: "",
      city_name: "",
      new_receiver: "",
      new_phone: "",
      new_price: "",
      new_price_remb: "",
    });

    const formObject = reactive({
      new_object: { id: "", name: "" },
      msg: "",
      adresse: "",
      reciever: "",
      phone: "",
      price: "",
    });

    const claimObject = reactive<Record<string, any>>({});

    // helper to reset formObject
    function resetFormObject() {
      Object.assign(formObject, {
        new_object: { id: "", name: "" },
        msg: "",
        adresse: "",
        reciever: "",
        phone: "",
        price: "",
      });
    }

    // reset helper
    function resetForm() {
      Object.assign(formClaim, {
        colis_id: 0,
        id: 0,
        customer_id: 0,
        msg: "",
        object: "",
        city_id: 0,
        statut: "",
        code_colis: "",
        city: { id: 0, city: "" },
        adresse: "",
        new_receiver: "",
        new_phone: "",
        new_price: "",
        new_price_remb: "",
        city_name: "",
      });
    }

    // Fetch data from API
    const fetchData = async (page = 1) => {
      loading.value = true;
      users.current_page = page;

      try {
        const res = await api.get(`/api/auth/listClaims`, {
          params: {
            searchTerm: users.searchTerm,
            searchCity: users.searchCity,
            searchCustomer: users.searchCustomer,
            searchStore: users.searchStore,
            searchObject: users.searchObject,
            searchStatut: users.searchStatut,
            searchSDate: users.searchSDate,
            searchEDate: users.searchEDate,
            searchUser: users.searchUser,
            page: users.current_page,
            per_page: users.per_page,
          },
        });

        rows.value = res.data.users.data;
        Object.assign(users, res.data.users);
      } catch (err) {
        console.error(err);
      } finally {
        loading.value = false;
      }
    };

    const clientList = ref<any[]>([]);
    
    const customer_filter = ref<any | null>(null);
    const object_filter = ref<any | null>(null); // on garde l'objet, pas l'id
    const status_filter = ref<number | string>(""); // "", 0, 1

    function applyFilters() {
      // IMPORTANT: on envoie des valeurs API dans "filters"
      users.searchCustomer = customer_filter.value?.id || "";
      users.searchObject = object_filter.value?.name || "";

      users.current_page = 1;
      fetchData(1);
    }

    function resetFilters() {
      customer_filter.value = null;
      object_filter.value = null;
      status_filter.value = "";
      users.searchCustomer = "";
      users.searchStatut = "";
      users.searchSDate = "";
      users.searchEDate = "";
      users.searchTerm = "";
      users.searchObject = "";

      users.current_page = 1;
      fetchData(1);
    }

    const searchTerm = ref("");
const debounceTimer = ref<number | undefined>(undefined);

    function handleInput() {
      if (debounceTimer.value) clearTimeout(debounceTimer.value);
      debounceTimer.value = window.setTimeout(() => {
        users.searchTerm = searchTerm.value;
        users.current_page = 1;
        fetchData(1);
      }, 500);
    }
    let debounceTimeout: number | undefined;

    // function onSearchClients(search, loading) {
    //   clearTimeout(searchTimeout)
    //   searchTimeout = setTimeout(() => {
    //     filterClients(search, loading)
    //   }, 300) // Debounce time in milliseconds
    // },

    async function filterClients(search: string, loading: { value: boolean }) {
      const query = search.trim().toLowerCase();

      if (!query) {
        clientList.value = [];
        return;
      }

      // Debounce to avoid too many API calls
      if (debounceTimeout) clearTimeout(debounceTimeout);

      debounceTimeout = window.setTimeout(async () => {
        try {
          const res = await api.get(`/api/auth/ListCustsFilter`, {
            params: { query },
          });
          clientList.value = res.data;
          clientList.value.unshift({ code: "0", name: "Tous" });
        } catch (error) {
          console.error("Error fetching clients:", error);
          clientList.value = [];
        }
      }, 300); // 300ms debounce
    }

    onMounted(async () => {
      fetchData();

      try {
        const response = await api.get(`/api/auth/general_list`);
        if (response && response.data) {
          settingData.value = response.data.data;
        }
      } catch (error) {
        console.error("Error fetching user data:", error);
      }

      try {
        const response = await api.get(`/api/auth/fetchObject`);
        if (response && response.data) {
          objectsClaim.value = response.data;
        }
      } catch (error) {
        console.error("Error fetching user data:", error);
      }
    });

    function getDate(value: any) {
      if (value) return moment.utc(String(value)).format("YYYY-MM-DD HH:mm");
      else return "";
    }

    async function exportClaims() {
      await api(
        `/api/auth/exportClaims?searchTerm=${users.searchTerm}&searchCustomer=${users.searchCustomer}&searchCity=${users.searchCity}&searchObject=${users.searchObject}&searchStatut=${users.searchStatut}&searchSDate=${users.searchSDate}&searchEDate=${users.searchEDate}`,
        {
          responseType: "arraybuffer",
        }
      ).then((res) => {
        let fileURL = window.URL.createObjectURL(
          new Blob([res.data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          })
        );
        let fileLink = document.createElement("a");
        fileLink.href = fileURL;
        fileLink.download = "ExportationClaims.xlsx";
        fileLink.click();
      });
    }

    async function showUpdate(row) {
      Object.keys(showClaim).forEach((key) => delete showClaim[key]);
      await nextTick();

      Object.assign(showClaim, row);
      fetchMessages(row.id);
      console.log(showClaim);
      await nextTick();

      const modalEl = document.getElementById("chatClaimModal");
      if (modalEl) {
        const modal = new Modal(modalEl);
        modal.show();
      }

      // your modal logic here
    }

    async function processedClaim(row) {
      if (row.statut === 3 || row.statut === 4) {
        showToast("Vous ne pouvez pas modifier cette réclamation", "error");
        return;
      }

      try {
        const res = await api.post(`/api/auth/processedClaim/${row.id}`);
        if (res.data === "success") {
          fetchData();
          showToast("La réclamation a été bien traitée", "success");
        } else {
          showToast("Vous ne pouvez pas traiter cette réclamation", "error");
        }
      } catch (error) {
        showToast("Une erreur est survenue lors du traitement", "error");
      }
    }

    function showDetails(row) {
      resetForm();
      Object.assign(formClaim, row);

      if (row.city) {
        formClaim.city_id = row.city.id;
        formClaim.city_name = row.city.city;
      }
      console.log(formClaim);
      const modalEl = document.getElementById("infosClaimModal");
      if (modalEl) {
        const modal = new Modal(modalEl);
        modal.show();
      }
    }

    async function fetchMessages(id: number | string) {
      const res = await api(
        `/api/auth/fetchMessages/${id}?user_id=${user?.id}`
      );
      chatMsgs.value = res.data
        .sort(
          (a: { time: string }, b: { time: string }) =>
            new Date(b.time).getTime() - new Date(a.time).getTime()
        )
        .reverse();
    }

    async function traitClaim() {
      try {
        const data = new FormData();
        data.append("id_colis", String(formClaim.colis_id));
        data.append("colis_code", formClaim.code_colis || "");
        data.append("city_id", String(formClaim.city_id || ""));
        data.append("city_name", formClaim.city || "");
        data.append("comment", formClaim.msg || "");
        data.append("adresse", formClaim.adresse || "");
        data.append("new_receiver", formClaim.new_receiver || "");
        data.append("new_phone", formClaim.new_phone || "");
        data.append("user_id", String(user?.id || ""));

        // 🔹 validations
        if (
          formClaim.object === "Changement Adresse/Client" &&
          (!formClaim.new_receiver ||
            !formClaim.new_phone ||
            !formClaim.adresse)
        ) {
          showToast("Merci de remplir tous les champs", "error");
          return;
        }

        if (formClaim.object === "Relance Colis/Client" && !formClaim.msg) {
          showToast("Merci de saisir un commentaire", "error");
          return;
        }

        // 🔹 API call
        const res = await api.post(
          `/api/auth/TraitClaim/${formClaim.id}`,
          data
        );

        if (res.data === "success") {
          fetchData();
          showToast("Vos données ont bien été enregistrées", "success");
          const modalEl = document.getElementById("infosClaimModal");
          if (modalEl) {
            const modal = new Modal(modalEl);
            modal.hide();
          }
        } else if (res.data === "error colis") {
          showToast("Vous ne pouvez pas traiter cette réclamation", "error");
        } else {
          showToast("Une erreur est survenue", "error");
        }
      } catch (error) {
        console.error("Erreur lors du traitement de la réclamation:", error);
        showToast("Erreur serveur. Veuillez réessayer.", "error");
      }
    }

    function showObject(row) {
      // reset both objects
      resetFormObject();
      Object.assign(claimObject, row);

      // copy row into form
      Object.assign(formObject, row);

      // override new_object
      formObject.new_object = {
        id: row.object_id || "",
        name: row.object || "",
      };

      console.log(formObject);
      const modalEl = document.getElementById("chnageObjectClaimModal");
      if (modalEl) {
        const modal = new Modal(modalEl);
        modal.show();
      }
    }

    async function editObjectClaim() {
      try {
        // ✅ validations
        if (!formObject.new_object.id || !formObject.new_object.name) {
          showToast("Merci de remplir tous les champs", "error");
          return;
        }

        if (
          formObject.new_object.name === "Changement de prix" &&
          !formObject.price
        ) {
          showToast("Merci de remplir les champs obligatoires", "error");
          return;
        }

        // ✅ build FormData safely
        const data = new FormData();
        data.append("claimId", String(claimObject.id || ""));
        data.append("objectId", String(formObject.new_object.id || ""));
        data.append("object", formObject.new_object.name || "");
        data.append("price", formObject.price || "");
        data.append("msg", formObject.msg || "");
        data.append("adresse", formObject.adresse || "");
        data.append("reciever", formObject.reciever || "");
        data.append("phone", formObject.phone || "");

        // ✅ API call
        const res = await api.post(`/api/auth/editObjectClaim`, data);

        if (res.data?.success) {
          fetchData();
          showToast(res.data.message || "Modification réussie", "success");
        } else {
          showToast(res.data.message || "Une erreur est survenue", "error");
        }
      } catch (error) {
        console.error("Erreur API editObjectClaim:", error);
        showToast("Erreur serveur. Veuillez réessayer.", "error");
      }
    }

    return {
      headers,
      rows,
      users,
      loading,
      fetchData,
      getDate,
      exportClaims,
      settingData,
      showDetails,
      processedClaim,
      showUpdate,
      chatMsgs,
      fetchMessages,
      showClaim,
      formClaim,
      traitClaim,
      showObject,
      formObject,
      objectsClaim,
      editObjectClaim,

      clientList,
      customer_filter,
      status_filter,
      applyFilters,
      resetFilters,
      filterClients,
      searchTerm,
      handleInput,
      object_filter
    };
  },
};
</script>

<style scoped>
/* ---------- Page header ---------- */
.ads-page-icon {
  width: 46px;
  height: 46px;
  border-radius: 12px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: rgba(6, 180, 138, 0.1);
  color: #06b48a;
  font-size: 20px;
}

/* ---------- Card ---------- */
.ads-card {
  border-radius: 14px;
  overflow: hidden;
  box-shadow: 0 4px 18px rgba(43, 42, 63, 0.06);
}

.ads-card .card-head {
  border-bottom: 1px solid #f0f0f5;
}

.ads-filters :deep(.v-select) {
  min-height: 44px;
}

/* ---------- Buttons ---------- */
.ads-btn-primary {
  background: #06b48a;
  padding: 11px 22px;
  border-radius: 8px;
  font-size: 14px;
  color: #fff;
}

.ads-btn-primary:hover {
  background: #059c78;
  color: #fff;
}

.ads-btn-outline {
  background: transparent;
  border: 1px solid #e2e2ea;
  color: #2b2a3f;
  padding: 10px 22px;
  border-radius: 8px;
  font-size: 14px;
}

.ads-btn-outline:hover {
  background: #f8f8fa;
  border-color: #d5d5e0;
}

/* ---------- Search ---------- */
.ads-search {
  min-width: 260px;
}

.ads-search-icon {
  position: absolute;
  left: 14px;
  top: 50%;
  transform: translateY(-50%);
  color: #a2a1bb;
  font-size: 14px;
}

.ads-search .form-control {
  border-radius: 8px;
  border: 1px solid #e2e2ea;
  height: 44px;
}

.ads-search .form-control:focus {
  border-color: #06b48a;
  box-shadow: 0 0 0 3px rgba(6, 180, 138, 0.12);
}

/* ---------- Table (vue-good-table) ---------- */
.ads-good-table :deep(table.vgt-table) {
  border: none;
}

.ads-good-table :deep(table.vgt-table thead th) {
  background: #f8f8fb;
  color: #8e8da1;
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 0.4px;
  border-bottom: 1px solid #f1f1f5;
  border-top: none;
  padding: 14px 16px;
}

.ads-good-table :deep(table.vgt-table td) {
  padding: 14px 16px;
  border-bottom: 1px solid #f1f1f5;
  vertical-align: middle;
  color: #2b2a3f;
  font-size: 14px;
}

.ads-good-table :deep(table.vgt-table tbody tr:hover) {
  background: #f8fbfa;
}

.ads-good-table :deep(table.vgt-table tbody tr:nth-child(even)) {
  background: #fbfbfd;
}

/* ---------- Status pills ---------- */
.status-pill {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 5px 12px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 500;
}

.status-pill-dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: currentColor;
}

.status-pill-success {
  background: rgba(6, 180, 138, 0.1);
  color: #06b48a;
}

.status-pill-danger {
  background: rgba(239, 41, 41, 0.1);
  color: #ef2929;
}

.status-pill-warning {
  background: rgba(243, 196, 76, 0.18);
  color: #c9932a;
}

.status-pill-primary {
  background: rgba(101, 96, 240, 0.1);
  color: #6560f0;
}

.status-pill-info {
  background: rgba(31, 177, 230, 0.1);
  color: #1fb1e6;
}

/* ---------- Modal ---------- */
.ads-modal-content {
  border: none;
  border-radius: 14px;
  overflow: hidden;
}

.ads-modal-header {
  background: #f8f8fb;
  border-bottom: 1px solid #f0f0f5;
  padding: 18px 25px;
}

.ads-modal-icon {
  width: 38px;
  height: 38px;
  border-radius: 10px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: rgba(6, 180, 138, 0.1);
  color: #06b48a;
}

.ads-modal-footer {
  border-top: 1px solid #f0f0f5;
  padding: 16px 25px;
}

.ads-modal-footer .ads-btn-primary,
.ads-modal-footer .ads-btn-outline {
  padding: 9px 20px;
}

/* ---------- Loading skeleton ---------- */
.skeleton-table {
  padding: 10px 0;
}

.skeleton-row {
  padding: 12px 0;
  border-bottom: 1px solid #f1f1f1;
  gap: 20px;
}

.skeleton-cell {
  flex: 1;
}

.skeleton-bar {
  display: block;
  height: 14px;
  border-radius: 4px;
  background: linear-gradient(90deg, #eef0f2 25%, #e2e5e9 37%, #eef0f2 63%);
  background-size: 400% 100%;
  animation: skeleton-shimmer 1.4s ease infinite;
}

@keyframes skeleton-shimmer {
  0% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0 50%;
  }
}

.empty-state {
  width: 100%;
}
</style>